var _path, _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.598 3.8147e-06C20.2736 3.8147e-06 19.196 1.04297 19.196 2.32529C19.196 2.6529 19.2672 2.96449 19.394 3.2475L16.5263 5.30784C16.1412 5.0536 15.6765 4.90448 15.1763 4.90448C14.5611 4.90448 14.0009 5.13151 13.5754 5.50111L11.0877 3.0948C11.1754 2.85352 11.2257 2.59526 11.2257 2.32529C11.2257 1.04297 10.1481 3.8147e-06 8.82369 3.8147e-06C7.49929 3.8147e-06 6.4217 1.04297 6.4217 2.32529C6.4217 2.59526 6.47192 2.85352 6.5597 3.0948L4.03904 5.53294C3.60955 5.14438 3.0348 4.90448 2.40199 4.90448C1.07759 4.90448 0 5.94745 0 7.22976C0 8.51208 1.07759 9.55505 2.40199 9.55505C3.72639 9.55505 4.80398 8.51208 4.80398 7.22976C4.80398 6.81954 4.69272 6.43444 4.49936 6.09953L6.92896 3.74947C7.36883 4.29681 8.05362 4.65093 8.82369 4.65093C9.59375 4.65093 10.2785 4.29681 10.7184 3.74947L13.105 6.05798C12.8962 6.40255 12.7743 6.80218 12.7743 7.22976C12.7743 8.51208 13.8519 9.55505 15.1763 9.55505C16.5007 9.55505 17.5783 8.51208 17.5783 7.22976C17.5783 6.69492 17.3889 6.20317 17.0743 5.80991L19.7941 3.85581C20.2347 4.34198 20.8791 4.65093 21.598 4.65093C22.9224 4.65093 24 3.6076 24 2.32529C24 1.04297 22.9224 3.8147e-06 21.598 3.8147e-06Z",
    fill: "#FFFF00"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 10.9091,
    width: 4.36364,
    height: 10.9091,
    rx: 0.2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 10.9091,
    width: 4.36364,
    height: 10.9091,
    rx: 0.2,
    stroke: "white",
    strokeWidth: 1.6,
    mask: "url(#path-2-inside-1)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.54565,
    y: 10.9091,
    width: 4.36364,
    height: 10.9091,
    rx: 0.2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.54565,
    y: 10.9091,
    width: 4.36364,
    height: 10.9091,
    rx: 0.2,
    stroke: "white",
    strokeWidth: 1.6,
    mask: "url(#path-3-inside-2)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.0908,
    y: 13.0909,
    width: 4.36364,
    height: 8.72727,
    rx: 0.2
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.0908,
    y: 13.0909,
    width: 4.36364,
    height: 8.72727,
    rx: 0.2,
    stroke: "white",
    strokeWidth: 1.6,
    mask: "url(#path-4-inside-3)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.6364,
    y: 8.72727,
    width: 4.36364,
    height: 13.0909,
    rx: 0.2
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6364,
    y: 8.72727,
    width: 4.36364,
    height: 13.0909,
    rx: 0.2,
    stroke: "white",
    strokeWidth: 1.6,
    mask: "url(#path-5-inside-4)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.2d3da06b.svg";
export { ForwardRef as ReactComponent };